import { features } from './features'; 

features.applicationType = 'gardengest';

/* features.fincaName = "Parque";
features.fincasName = "Parques";
features.parcelaName = "Jardin";
features.parcelasName = "Jardines"; */

features.fincaName = 'Dirección';
features.fincasName = 'Direcciones';
features.parcelaName = 'Unidad';
features.parcelasName = 'Unidades';

features.showEstadisticas = false;
features.showAnalisis = false;
features.showCargaPAC = false;
features.showVisitas = false;
features.showVentas = false;
features.showPartida = true;
features.puedeImprimir = true;
features.showAbonado = true;
features.showMapas = true;
features.hasAplicadores = true;
features.showVademecumListadoProductos = true;
features.showVademecumMenu = true;
features.showStock = true;
features.showPhCaldo = true;
features.showEnviarWhatsapp = true;
features.showEnviarCorreo = true;
features.showEnviarWhatsappVisitas = false;
features.showEnviarCorreoVisitas = false;
features.showTareasBio = false;
features.showOrdenAplicacionProductos = true;
features.showMeteoBtn = true;
features.showRecetaGlobalGAP = false;
features.adminCanSeeAllRecords = true;
features.showVisitasUploadPhotos = false;
features.showMapasSatelite = false;
features.showAnalisisSectorParcelas = true;
features.showTareasSiembra = false;
features.showRopoRomaRegepa = true;
features.showConsultaRopo = false;
features.showMotivo = true;
features.showStock = true;
features.showStockTipoDeDato = true;
features.showStockProveedor = true;
features.showStockEnvase = true;
features.showReto = false;
features.showVentusky = true;
features.showFotoTrajador = true;
features.showTareasFertilizantes = false;
features.showProductosFeritilizantes = false;
features.showVademecumListadoProductos = false;
features.showSigPacParcela = false;
features.showCuadernoDeCampo = true;
features.puedeImprimir = true;
features.showTratamientosMenu = true;
features.showRegistroTratamiento = true;
features.textoSuperficie = 'm²';
features.showProductosFeritilizantes = true;
features.showTareasFertilizantes = true;
features.showClientesNotas = true;
features.showHistoricoFT = true;
features.showTareasMto = true;
features.showWidthFertilizanteNombre = true;
features.clientesMostrarTodosDefault = true;
features.showFincasInformeTratamientos = true;
features.timeStartStopTareas = true;

features.userCanSeeAllRecords = true;
features.timeStartStopTareas = true;
features.showTareasFitoBetweenDates = true;
features.userSoloCanSeeInfo = true;

// BUSINESS INTELLIGENCE
features.showEstadisticas = true;
features.showUsuariosLogs = true;
export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://demo.gardengest.com/',
    logoUrl: 'assets/logo_demogardengest.png',
    appName: 'demogardengest',
    features: features
};